import { InjectionToken } from '@angular/core';
import { CommonConfig } from './common.config';

export const COMMON_CONFIG = new InjectionToken<CommonConfig>('CommonConfig');
